angular.module('lsnBase.deprecated.models')
  .factory('SalesProductModel', ['LsnSalesProductModelV1',
    function(LsnSalesProductModelV1) {
      return LsnSalesProductModelV1;
    }
  ]);